import React from 'react';
import TextField from '@mui/material/TextField';
import { FIELD_SX } from '../WeldAssure/BrandedForm';
const CTextField = (props) => {
  // Supports BOTH contracts:
  //  - controlled: pass value + setValue  (e.g. AddJob)
  //  - uncontrolled: pass onChange + (optional) defaultValue  (legacy forms)
  const controlled = props.value !== undefined && typeof props.setValue === 'function';
  return (
    <TextField
      id={props.label}
      label={props.label}
      variant="outlined"
      sx={{ ...FIELD_SX, ...(props.sx || {}) }}
      disabled={props.disabled ? props.disabled : false}
      fullWidth={props.fullWidth ? props.fullWidth : true}
      style={{
        margin: props.margin ? props.margin : '',
        width: props.width ? props.width : '',
      }}
      required={props.required ? props.required : false}
      onChange={controlled ? (e) => props.setValue(e.target.value) : props.onChange}
      name={props.name ? props.name : ''}
      type={props.type ? props.type : 'text'}
      {...(controlled
        ? { value: props.value }
        : { defaultValue: props.defaultValue ? props.defaultValue : '' })}
    />
  );
};

export default CTextField;
